import {CompanyAddressDetails, getAddressValidationError} from './address-details';
import {renewalConsent} from './renewal-signature';
import consent from '../../../backend/resources/dissolution-consent.json';
import reasons from '../../../backend/resources/dissolution-reasons.json';

export const dissolutionConsent = {...renewalConsent, ...consent};
export const dissolutionReasons = reasons;
export interface DissolutionApplication {
    signerName: string;
    signerTitle: string;
    signerAddress: CompanyAddressDetails;
    effectiveDate: string;
    dissolutionReason: string;
    otherReason: string;
    certifiedCopy: boolean;
}
export interface DissolutionDateBounds {min: string; max: string}

export function emptyDissolutionApplication(today = ''): DissolutionApplication {
    return {signerName: '', signerTitle: '', signerAddress: {country: 'US'},
        effectiveDate: today, dissolutionReason: '', otherReason: '', certifiedCopy: false};
}

export function dissolutionApplicationError(application: DissolutionApplication, bounds: DissolutionDateBounds): string | null {
    const validDate = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value)
        && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
    if (!validDate(application.effectiveDate) || application.effectiveDate < bounds.min || application.effectiveDate > bounds.max) {
        return 'Choose a dissolution date from today through 90 days ahead.';
    }
    if (!reasons.some(reason => reason.value === application.dissolutionReason)) return 'Select the authorization or event resulting in dissolution.';
    if (application.dissolutionReason === 'other' && (!application.otherReason.trim() || [...application.otherReason.trim()].length > 240)) {
        return 'Enter a reason for dissolution using no more than 240 characters.';
    }
    if (!application.signerName.trim()) return "Enter the authorized person's legal name.";
    if (!application.signerTitle.trim()) return "Enter the authorized person's title or capacity.";
    return getAddressValidationError(application.signerAddress);
}
